import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ButtonLink from '../utility/ButtonLink';
import { productClickGA } from '../../js/analytics';
import { Carousel } from 'react-responsive-carousel';

const carouselBgStyle = ( url, positionX, positionY ) => { // eslint-disable-line
  return {
    background: `url(${url}) no-repeat center/cover`,
    backgroundPositionY: (positionY) ? positionY : 'center',
    backgroundPositionX: (positionX) ? positionX : 'center'
  };
};

const carouselDisplay = (
  { desktop, mobile, dekstopBGPositionX = 'center', dekstopBGPositionY = 'center', mobileBGPositionX = 'center', mobileBGPositionY = 'center' } // eslint-disable-line
) => (
  <>
    <div
      className='fe-home-banner-carousel-item desktop'
      style={carouselBgStyle(desktop, dekstopBGPositionX, dekstopBGPositionY)}
    />
    <div className='fe-home-banner-carousel-item' style={carouselBgStyle(mobile, mobileBGPositionX, mobileBGPositionY)} />
  </>
);

class BannerCarousel extends Component {
  constructor(props) {
    super(props);
    this.bannerSlider = React.createRef();
    this.goToSpecificSlide = false;
  }

  componentDidMount() {
    if(window.location.hash.length){
      // remove the # from the hash and convert to integer
      this.goToSpecificSlide = parseInt(window.location.hash.replace('#', ''), 10)-1;
      // this.goToSpecificSlide = 1;
    }
  }

  render() {
    const { carouselImages, t } = this.props;

    // check if react-responsive-carousel already initialized
    if (this.bannerSlider){
      if (this.bannerSlider.state) {
        if (this.bannerSlider.state.selectedItem === 0 && this.goToSpecificSlide) {
          // set the current slide to the one specified in the URL
          if (this.goToSpecificSlide < carouselImages.length && this.goToSpecificSlide >= 0){
            this.bannerSlider.setState({ selectedItem: this.goToSpecificSlide });
          }
          this.goToSpecificSlide = false;
        }
      }
    }

    // check if react-responsive-carousel already initialized
    if (this.bannerSlider){
      if (this.bannerSlider.state) {
        if (this.bannerSlider.state.selectedItem === 0 && this.goToSpecificSlide) {
          // set the current slide to the one specified in the URL
          if (this.goToSpecificSlide < carouselImages.length && this.goToSpecificSlide >= 0){
            this.bannerSlider.setState({ selectedItem: this.goToSpecificSlide });
          }
          this.goToSpecificSlide = false;
        }
      }
    }

    // remove the banner if hide is set to true using for loop
    for (let i = 0; i < carouselImages.length; i++) {
      if (carouselImages[i].hide) {
        carouselImages.splice(i, 1);
        i--;
      }
    }

    const notSingle = carouselImages.length > 1;
    
    return (
      <>
        {/* <Helmet>
          <title>
            {t('ourStory:title')} | {SITE_TITLE}
          </title>
        </Helmet> */}

        {/* With Carousel */}
        <Carousel
          className='fe-home-banner-carousel'
          showArrows={notSingle}
          showStatus={false}
          showIndicators={notSingle}
          showThumbs={false}
          stopOnHover={false}
          infiniteLoop={notSingle}
          autoPlay={notSingle}
          // autoPlay={false}
          transitionTime={400}
          emulateTouch={notSingle}
          swipeScrollTolerance={5}
          swipeable={true}
          interval={5000}
          ref={bannerSlider => (this.bannerSlider = bannerSlider)}
        >
          {carouselImages.map((image, i) => {
            const isExternalLink = image.img_url && /^http/.test(image.url);
            return (
              <div key={i} className='fe-home-banner-carousel-item-container'>
                {carouselDisplay(image.img_url)}
                <div className='fe-carousel-banner-content'>
                  <div className='fe-banner-title'>{image.title}</div>
                  <div className='fe-banner-date'>{image.subtitle}</div>
                  {image.display_button ? (
                    isExternalLink ? (
                    <a href={image.url} className='fe-u-btn'>
                      {image.button_text ? image.button_text : t('gen:bookNow')}
                    </a>                    
                    ) : (
                      <ButtonLink
                        className={`fe-u-btn ${image.button ? 'fe-book-now-grey' : ''}`}
                        onClick={() =>
                          productClickGA(
                            image.tripSlug,
                            image.title
                          )
                        }
                        to={`/trips/${image.url}`}
                      >
                        {image.button_text ? image.button_text : t('gen:bookNow')}
                      </ButtonLink>
                    )                 
                  ) : null
                  }
                </div>
              </div>
            );
          })}
        </Carousel>
      </>
    );
  }
}

BannerCarousel.propTypes = {
  carouselImages: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ tripState }) => ({
  carouselImages: tripState.homepageBanners
});

export default withTranslation()(connect(mapStateToProps)(BannerCarousel));
